import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import router from "routes";
import { get } from "util/requests";
import colors from "colors";
import moment from "moment";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import styles from "../drug_management.module.css";

const columns = (selectedDrugs) => [
  {
    field: "selected",
    headerName: "",
    width: 30,
    headerClassName: "columnHeaders",
    renderCell: ({ row }) => (
      <div className={styles.circle_cell}>
        {selectedDrugs.includes(row.id) ? (
          <CircleIcon sx={{ fontSize: "14px" }} />
        ) : (
          <CircleOutlinedIcon sx={{ fontSize: "14px" }} />
        )}
      </div>
    ),
  },
  {
    field: "name",
    headerName: "Drug",
    type: "string",
    width: 140,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "label_id",
    headerName: "Label ID",
    type: "string",
    width: 140,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "subject_id",
    headerName: "Subject Allocation",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "allocated_on",
    headerName: "Allocated On",
    width: 120,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "expiry_date",
    headerName: "Expiry Date",
    width: 150,
    align: "center",
    headerAlign: "center",
    renderCell: ({ row }) => {
      return moment(row.expiry_date).format("yyyy-MMM-DD");
    },
  },
  {
    field: "status",
    headerName: "Status",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "location",
    headerName: "Location",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "location_status",
    headerName: "Sub Location",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "next_location",
    headerName: "Next Location",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "modified_on",
    headerName: "Modified On",
    width: 160,
    renderCell: ({ row }) => {
      return moment(row.modified_on).format("yyyy-MMM-DD HH:mm:ss");
    },
  },
];

export default function DrugTable(props) {
  const { selectedDrugs, setSelectedDrugs, drugs, drugConfig, setShowingDrugModal } = props;

  return (
    <DataGrid
      rows={drugs}
      columns={columns(selectedDrugs)}
      disableColumnSelector
      disableRowSelectionOnClick
      disableColumnMenu
      pageSize={10}
      rowsPerPageOptions={[10]}
      hideFooterSelectedRowCount
      pageSizeOptions={[10]}
      columnHeaderHeight={34}
      rowHeight={34}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 12,
          },
        },
      }}
      sx={{
        boxShadow: 0,
        border: 1,
        borderColor: "#f0f0f0",
        "& .MuiDataGrid-cell:hover": {
          color: "#8349fd",
          cursor: "pointer",
        },
        "& .MuiDataGrid-cell:focus": {
          cursor: "pointer",
          outline: "none",
        },
        "& .MuiDataGrid-topContainer .MuiDataGrid-columnHeader ": {
          // backgroundColor: "#f7f3fe",
          backgroundColor: colors.table_header_background,
        },
        "& .MuiDataGrid-topContainer .MuiDataGrid-filler ": {
          // backgroundColor: "#f7f3fe",
          backgroundColor: colors.table_header_background,
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 700,
          color: "#333",
        },
      }}
      onCellClick={(params) => {
        let selected = [...selectedDrugs];
        if (params.field === "selected") {
          if (selectedDrugs.includes(params.id)) {
            selected = selected.filter((id) => id !== params.id);
          } else {
            selected.push(params.id);
          }

          setSelectedDrugs(selected);
        } else {
          setShowingDrugModal(params.row);
        }
      }}
    />
  );
}
